import { z, ZodIssueCode } from 'zod'
import { FieldFilterRestrictionOperator } from '@portal/pkg-api/gen/admin'

export const NO_VALUE_OPERATORS = [
  FieldFilterRestrictionOperator.IS_EMPTY,
  FieldFilterRestrictionOperator.IS_PRESENT,
]

export const FieldFilterRestrictionSchema = z.object({
  dtype: z.literal('F'),
  operand1: z.number().min(1),
  operator: z.nativeEnum(FieldFilterRestrictionOperator),
  // Optional here, but handled in union `superRefine` below as it's dependent on `operator` value.
  operand2Value: z.string().optional(),
})

export type FieldFilterRestriction = z.infer<typeof FieldFilterRestrictionSchema>

export const LogicalFilterRestrictionSchema = z.object({
  dtype: z.literal('L'),
  logicalOperator: z.enum(['AND', 'OR', 'NOT']),
})

export type LogicalFilterRestriction = z.infer<typeof LogicalFilterRestrictionSchema>

export const FilterRestrictionSchema = z
  .discriminatedUnion('dtype', [LogicalFilterRestrictionSchema, FieldFilterRestrictionSchema])
  .superRefine((r, ctx) => {
    if (
      isFieldFilterRestriction(r) &&
      !NO_VALUE_OPERATORS.includes(r.operator) &&
      !r.operand2Value
    ) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        path: ['operand2Value'],
        params: {
          i18n: 'validator.required',
        },
      })
    }
  })

export type FilterRestrictionType = z.infer<typeof FilterRestrictionSchema>

export const isFieldFilterRestriction = (
  restriction: FilterRestrictionType,
): restriction is FieldFilterRestriction => restriction.dtype === 'F'

export const isLogcialFilterRestriction = (
  restriction: FilterRestrictionType,
): restriction is LogicalFilterRestriction => restriction.dtype === 'L'
